import api from '@/api/client'

/**
 * Auth service
 * Thin wrappers around auth-related endpoints.
 */

/**
 * Fetch current authenticated user profile.
 * @returns {Promise<any>} user object or throws
 */
export const getMe = async () => {
  const res = await api.get('me/')
  return res.data
}

/**
 * Obtain JWT tokens for a username/password.
 * @param {string} username
 * @param {string} password
 */
export const login = async (username, password) => {
  const res = await api.post('token/', { username, password })
  return res.data
}

/**
 * Create a new user account.
 * @param {{username:string,email:string,password:string,role?:string}} payload
 */
export const register = async (payload) => {
  const roleRaw = String(payload?.role || '').toLowerCase()
  // Backend accepts only 'lecturer' or 'student' (legacy 'teacher' treated as lecturer)
  const role = roleRaw === 'lecturer' || roleRaw === 'teacher' ? 'lecturer' : 'student'
  const res = await api.post('register/', { ...payload, role })
  return res.data
}

/**
 * Update the current user's profile (optional fields)
 * @param {{first_name?: string, last_name?: string, email?: string}} payload
 */
export const updateMe = async (payload) => {
  const res = await api.patch('me/', payload)
  return res.data
}

export const issueWagtailTicket = async () => {
  const response = await api.post('wagtail/sso/')
  return response.data
}

export const requestPasswordReset = async email => {
  const response = await api.post('password-reset/', { email })
  return response.data
}

export const confirmPasswordReset = async (uid, token, newPassword) => {
  const response = await api.post('password-reset/confirm/', { uid, token, new_password: newPassword })
  return response.data
}
